export const studyPeriodSectionMessagesEn = {
  // Study Period Section
  'projects.cohortBuilderPage.studyPeriodSection.title': 'Study period',
  'projects.cohortBuilderPage.studyPeriodSection.editCardTitle': 'Configure study period',
  'projects.cohortBuilderPage.studyPeriodSection.cancelBtnCancel': 'Cancel',
  'projects.cohortBuilderPage.studyPeriodSection.cancelBtClose': 'Close',
  'projects.cohortBuilderPage.studyPeriodSection.saveBtn': 'Save',
  'projects.cohortBuilderPage.studyPeriodViewCard.studyPeriodLabel': 'Date range',
  'projects.cohortBuilderPage.studyPeriodViewCard.baselinePeriodLabel': 'Baseline period',
  'projects.cohortBuilderPage.studyPeriodViewCard.followUpPeriodLabel': 'Follow-up period',
  'projects.cohortBuilderPage.studyPeriodViewCard.baselineValue': '{days} days before index date',
  'projects.cohortBuilderPage.studyPeriodViewCard.followUpValue': '{days} days after index date',

  'projects.cohortBuilderPage..studyPeriodDialogStudyPeriod.label': 'Date range',
  'projects.cohortBuilderPage.studyPeriodDialogStudyPeriod.checkboxLabel':
    'Restrict all events to occur within a specific date range',
  'projects.cohortBuilderPage.studyPeriodDialogStudyPeriod.startDateLabel': 'Start date',
  'projects.cohortBuilderPage.studyPeriodDialogStudyPeriod.endDateLabel': 'End date',
  'projects.cohortBuilderPage.studyPeriodDialogStudyPeriod.info':
    'Setting a date range will require that all events in the cohort definition occur within this time window, inclusive of the date bounds. Events outside of this date range will not be considered when cohort criteria are evaluated.',

  'projects.cohortBuilderPage.studyPeriodDialogBaselinePeriod.title': 'Baseline period',
  'projects.cohortBuilderPage.studyPeriodDialogBaselinePeriod.checkboxLabel':
    'Require a minimum baseline period',
  'projects.cohortBuilderPage.studyPeriodDialogBaselinePeriod.baselineEditLabel': 'Value',
  'projects.cohortBuilderPage.studyPeriodDialogBaselinePeriod.baselineEditPlaceholder':
    'Enter a number',
  'projects.cohortBuilderPage.studyPeriodDialogBaselinePeriod.baselineEditMessage':
    'days before index date',
  'projects.cohortBuilderPage.studyPeriodDialogBaselinePeriod.infoLine1':
    'Subjects must meet the specified minimum baseline period to be included in the cohort.',
  'projects.cohortBuilderPage.studyPeriodDialogBaselinePeriod.infoLine2':
    "Baseline period will be calculated as days between a subject’s start of observability and the index date. A subject's observability begins at the later of their observation period start date or the study period start date, if defined above.",
  'projects.cohortBuilderPage.studyPeriodDialogBaselinePeriodCheckbox.title.disabled':
    'Baseline period is disabled until an index date has been set',

  'projects.cohortBuilderPage.studyPeriodDialogFollowUpPeriod.title': 'Follow-up period',
  'projects.cohortBuilderPage.studyPeriodDialogFollowUpPeriod.checkboxLabel':
    'Require a minimum follow-up period',
  'projects.cohortBuilderPage.studyPeriodDialogFollowUpPeriod.followUpEditLabel': 'Value',
  'projects.cohortBuilderPage.studyPeriodDialogFollowUpPeriod.followUpEdiPlaceholder':
    'Enter a number',
  'projects.cohortBuilderPage.studyPeriodDialogFollowUpPeriod.followUpEditMessage':
    'days after index date',
  'projects.cohortBuilderPage.studyPeriodDialogFollowUpPeriod.infoLine1':
    'Subjects must meet the specified minimum follow-up period to be included in the cohort.',
  'projects.cohortBuilderPage.studyPeriodDialogFollowUpPeriod.infoLine2':
    "Follow-up period will be calculated as days between the index date and the subject’s end of observability. A subject's observability ends at the earlier of their observation period end date or the study period end date, if defined above.",
  'projects.cohortBuilderPage.studyPeriodDialogFollowUpPeriodCheckbox.title.disabled':
    'Follow-up period is disabled until an index date has been set',
};
